(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["base-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-uannounce]').forEach(function (bar) {
      var slides = bar.querySelectorAll('.uannounce__slide');
      if (slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var index = 0;
      setInterval(function () {
        slides[index].classList.remove('uannounce__slide--active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('uannounce__slide--active');
      }, 4000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["base-buy-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ubuybox]').forEach(function (root) {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var stage = root.querySelector('[data-ubuybox-stage]');
      var track = root.querySelector('[data-ubuybox-track]');
      var slides = root.querySelectorAll('[data-ubuybox-slide]');
      var thumbs = root.querySelectorAll('[data-ubuybox-thumb]');

      if (track && thumbs.length) {
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var index = parseInt(thumb.getAttribute('data-index'), 10);
            var slide = slides[index];
            if (!slide) return;
            slide.scrollIntoView({
              behavior: prefersReduced ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'center',
            });
          });
        });

        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                  var index = Array.prototype.indexOf.call(slides, entry.target);
                  thumbs.forEach(function (thumb, i) {
                    thumb.classList.toggle('ubuybox__thumb--active', i === index);
                  });
                }
              });
            },
            { root: track, threshold: [0.6] }
          );
          slides.forEach(function (slide) {
            observer.observe(slide);
          });
        }
      }

      var qtyInput = root.querySelector('[data-ubuybox-qty-input]');
      var qtyMinus = root.querySelector('[data-ubuybox-qty-minus]');
      var qtyPlus = root.querySelector('[data-ubuybox-qty-plus]');

      function clampQty(value) {
        var n = parseInt(value, 10);
        if (isNaN(n) || n < 1) n = 1;
        return n;
      }

      if (qtyInput && qtyMinus && qtyPlus) {
        qtyMinus.addEventListener('click', function () {
          qtyInput.value = Math.max(1, clampQty(qtyInput.value) - 1);
        });
        qtyPlus.addEventListener('click', function () {
          qtyInput.value = clampQty(qtyInput.value) + 1;
        });
        qtyInput.addEventListener('change', function () {
          qtyInput.value = clampQty(qtyInput.value);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["base-historia"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-uhist]').forEach(function (section) {
      if (window.matchMedia('(min-width: 768px)').matches) return;

      var track = section.querySelector('[data-uhist-track]');
      var frames = section.querySelectorAll('[data-uhist-frame]');
      var dots = section.querySelectorAll('[data-uhist-dot]');
      var currentEl = section.querySelector('[data-uhist-current]');
      var prevBtn = section.querySelector('[data-uhist-prev]');
      var nextBtn = section.querySelector('[data-uhist-next]');
      var hint = section.querySelector('[data-uhist-hint]');
      if (!track || !frames.length) return;

      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var activeIndex = 0;
      var hintDismissed = false;

      function dismissHint() {
        if (hintDismissed || !hint) return;
        hintDismissed = true;
        hint.classList.add('uhist__swipe-hint--hidden');
      }

      function setActive(index) {
        activeIndex = index;
        dots.forEach(function (dot, i) {
          dot.classList.toggle('uhist__dot--active', i === index);
        });
        if (currentEl) currentEl.textContent = index + 1;
      }

      function scrollToIndex(index) {
        index = Math.max(0, Math.min(frames.length - 1, index));
        var frame = frames[index];
        if (!frame) return;
        dismissHint();
        frame.scrollIntoView({
          behavior: prefersReduced ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                var index = Array.prototype.indexOf.call(frames, entry.target);
                if (index !== -1) setActive(index);
              }
            });
          },
          { root: track, threshold: [0.6] }
        );
        frames.forEach(function (frame) { observer.observe(frame); });
      }

      track.addEventListener(
        'scroll',
        function () {
          dismissHint();
        },
        { passive: true }
      );
      track.addEventListener('touchstart', dismissHint, { passive: true });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          scrollToIndex(i);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollToIndex(activeIndex - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollToIndex(activeIndex + 1);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["base-opinie"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-uopin-video]').forEach(function (wrap) {
      var playBtn = wrap.querySelector('.uopin__play');
      var template = wrap.querySelector('.uopin__video-template');
      if (!playBtn || !template) return;

      playBtn.addEventListener('click', function () {
        var poster = wrap.querySelector('.uopin__video-poster');
        var content = template.content.cloneNode(true);
        if (poster) poster.remove();
        playBtn.remove();
        wrap.appendChild(content);
        var video = wrap.querySelector('video.uopin__player');
        if (video) {
          video.play().catch(function () {});
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["base-owady"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Fix mobile: brak CSS :hover do pauzy (telefon "utykał" w stanie hover po tapnięciu).
    // Pauza idzie przez JS klasę .is-paused, identycznie na desktopie i mobile.
    document.querySelectorAll('.uowady__ticker').forEach(function(ticker) {
      var track = ticker.querySelector('.uowady__track');
      if (!track) return;

      var resumeTimeout = null;
      ticker.addEventListener('pointerdown', function() {
        track.classList.add('is-paused');
        clearTimeout(resumeTimeout);
        resumeTimeout = setTimeout(function() {
          track.classList.remove('is-paused');
        }, 1500);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["base-porownanie"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.uporo[data-animate="true"]');
    if (!sections.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (section) {
      var rows = section.querySelectorAll('.uporo__row');

      if (prefersReduced || !('IntersectionObserver' in window)) {
        rows.forEach(function (row) {
          row.classList.add('uporo__row--visible');
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            rows.forEach(function (row, index) {
              setTimeout(function () {
                row.classList.add('uporo__row--visible');
              }, index * 50);
            });
            obs.unobserve(entry.target);
          });
        },
        { threshold: 0.15 }
      );

      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["base-sticky-produkt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-usticky-produkt]').forEach(function (bar) {
      var buyBox = document.getElementById('buy-box');
      var footer = document.querySelector('.ufooter') || document.querySelector('footer');
      var priceEl = bar.querySelector('[data-usticky-price]');
      var cta = bar.querySelector('[data-usticky-cta]');

      var pastBuyBox = false;
      var footerVisible = false;

      function update() {
        if (pastBuyBox && !footerVisible) {
          bar.classList.add('usticky--visible');
        } else {
          bar.classList.remove('usticky--visible');
        }
      }

      if (buyBox && 'IntersectionObserver' in window) {
        var buyBoxObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                pastBuyBox = false;
              } else if (entry.boundingClientRect.bottom <= 0) {
                pastBuyBox = true;
              } else {
                pastBuyBox = false;
              }
              update();
            });
          },
          { threshold: 0 }
        );
        buyBoxObserver.observe(buyBox);
      } else {
        var threshold = buyBox ? buyBox.offsetHeight : 400;
        var onScroll = function () {
          pastBuyBox = window.scrollY > threshold;
          update();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      if (footer && 'IntersectionObserver' in window) {
        var footerObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              footerVisible = entry.isIntersecting;
              update();
            });
          },
          { threshold: 0 }
        );
        footerObserver.observe(footer);
      }

      document.addEventListener('base:variant-change', function (evt) {
        if (priceEl && evt.detail.priceHtml) priceEl.textContent = evt.detail.priceHtml;
        if (cta) cta.disabled = !evt.detail.available;
      });

      if (cta) {
        cta.addEventListener('click', function () {
          var realCta = document.querySelector('[data-ubuybox-cta]');
          if (realCta) realCta.click();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["base-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-usticky]').forEach(function (bar) {
      var hero = document.getElementById('hero');
      var footer = document.querySelector('.ufooter') || document.querySelector('footer');

      var pastHero = false;
      var footerVisible = false;

      function update() {
        if (pastHero && !footerVisible) {
          bar.classList.add('usticky--visible');
        } else {
          bar.classList.remove('usticky--visible');
        }
      }

      if (hero && 'IntersectionObserver' in window) {
        var heroObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                pastHero = false;
              } else if (entry.boundingClientRect.bottom <= 0) {
                pastHero = true;
              } else {
                pastHero = false;
              }
              update();
            });
          },
          { threshold: 0 }
        );
        heroObserver.observe(hero);
      } else {
        var threshold = hero ? hero.offsetHeight : 400;
        var onScroll = function () {
          pastHero = window.scrollY > threshold;
          update();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      if (footer && 'IntersectionObserver' in window) {
        var footerObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              footerVisible = entry.isIntersecting;
              update();
            });
          },
          { threshold: 0 }
        );
        footerObserver.observe(footer);
      }

      var cta = bar.querySelector('[data-usticky-cta]');
      if (cta) {
        cta.addEventListener('click', function (e) {
          var href = cta.getAttribute('href');
          if (!href || href.charAt(0) !== '#') return;
          var target = document.getElementById(href.slice(1));
          if (!target) return;
          e.preventDefault();
          var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
